import React from "react";
import Modal from "react-bootstrap/Modal";
import { BotonDangerText, BotonPrimaryText } from "../../components/BotonesCustom";

const ImportarUnidadesModal = ({
  show,
  onClose,
  onFileChange,
  onImport,
  importFile,
  datosImportacion,
  isImporting,
}) => {
  return (
    <Modal
      show={show}
      onHide={isImporting ? null : onClose}
      backdrop={isImporting ? "static" : true}
      keyboard={!isImporting}
    >
      <Modal.Header closeButton={!isImporting}>
        <Modal.Title>
          {isImporting && (
            <div
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
          )}
          {isImporting ? "Procesando importación..." : "Importar"}
        </Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="form-group">
            <input
              type="file"
              className="form-control"
              id="file_import"
              name="file_import"
              onChange={onFileChange}
            />
          </div>
          {datosImportacion && (
            <div>
              <h3>{datosImportacion.message}</h3>
              {datosImportacion.fallos_list && (
                <ul>
                  {datosImportacion.fallos_list.map((fallo, index) => (
                    <li key={index}>
                      {fallo.nombre}, {fallo.vivienda}, {fallo.email},{" "}
                      {fallo.mensaje}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <BotonDangerText onClick={onClose} disabled={isImporting}>
            <i className="fas fa-times me-2"></i>
            Cerrar
          </BotonDangerText>
          <BotonPrimaryText onClick={onImport} disabled={isImporting || !importFile}>
            {isImporting ? (
              <>
                <div
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Procesando archivo...
              </>
            ) : (
              <>
                <i className="fas fa-upload me-2"></i>
                Importar
              </>
            )}
          </BotonPrimaryText>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ImportarUnidadesModal;
